/**
 * Utilities for persisting whether the main left menu is expanded, in
 * localStorage. The menu is expanded by default.
 */
const SHOW_MENU_KEY = 'show_menu';
const DEFAULT_SHOW_MENU = true;
export const loadShowMenu = () => {
    try {
        const stored = localStorage.getItem(SHOW_MENU_KEY);
        return stored === null ? DEFAULT_SHOW_MENU : stored === 'true';
    }
    catch (error) {
        console.warn('Failed to load menu state from localStorage:', error);
        return DEFAULT_SHOW_MENU;
    }
};
export const saveShowMenu = (showMenu) => {
    try {
        localStorage.setItem(SHOW_MENU_KEY, String(showMenu));
    }
    catch (error) {
        console.warn('Failed to save menu state to localStorage:', error);
    }
};
